@if (productInfo?.length) {
  <ul
    class="offer-info list-no-default-spacing list-unstyled"
    [class.offer-info--horizontal-margin]="horizontalMargins"
    [class.mt-1]="marginTop"
  >
    @for (info of productInfo; track info) {
      <li>
        <span>
          @if (info.icon) {
            <fa-icon
              [icon]="info.icon | scIcon"
              class="fa-icon"
              [fixedWidth]="true"
            ></fa-icon>
          }
          @if (info.key) {
            <span>{{ info.key }}</span>
          }
        </span>
        @if (info.value) {
          <span class="fw-bold">{{ info.value }}</span>
        }
      </li>
    }
  </ul>
}
